// extracted by mini-css-extract-plugin
export default {"base-text":"BaseText_base-text__uxHit","checkbox-wrapper":"BaseText_checkbox-wrapper__q9P1k","checkbox":"BaseText_checkbox__0-jOZ","base-text-body":"BaseText_base-text-body__9Fz2h"};